import { useQueryClient } from "@tanstack/react-query"
import { useToast } from "react-native-toast-notifications"
import { useDispatch, useSelector } from "react-redux"
import api from "../utils/api"
import useActiveAdminCommunity from "./useActiveAdminCommunity"
import { statusUpdated } from "../store/Reducers/status"
import { useState } from "react"

export default function useCommunitySettings() {
  const { communityId, community } = useActiveAdminCommunity()
  const [isUpdating, setIsUpdating] = useState(false)
  const toast = useToast()
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const staff = useSelector((state: any) => state.status?.staff)

  const updateSettings = async (path: string, value: any) => {
    setIsUpdating(true)
    try {
      const response = await api.patch(`/communities/${communityId}/settings`, {
        path,
        value
      })

      // getSettingValue lee de `status.staff` (Redux), no de React Query: se actualiza ahí con
      // los settings que regresa el PATCH para que la pantalla refleje el cambio sin recargar
      const settings = response.data?.settings
      if (settings && Array.isArray(staff)) {
        dispatch(statusUpdated({
          staff: staff.map((c: any) => (c.uuid === communityId ? { ...c, settings } : c)),
        }))
      }

      queryClient.invalidateQueries({ queryKey: ['community', communityId] })

      toast.show("Configuración actualizada", { type: "success" })
      return response.data
    } catch (error: any) {
      console.error("Error updating settings:", error)
      toast.show(error.response?.data?.message || "Error al actualizar configuración", { type: "warning" })
      throw error
    } finally {
      setIsUpdating(false)
    }
  }

  const getSettingValue = (path: string, defaultValue: any = null) => {
    if (!community?.settings) return defaultValue

    const keys = path.split('.')
    let value = community.settings

    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key]
      } else {
        return defaultValue
      }
    }

    return value ?? defaultValue
  }

  return {
    updateSettings,
    getSettingValue,
    isUpdating,
    settings: community?.settings ?? {},
  }
}
